import React, { useState } from "react";
import tw from "tailwind-styled-components";
import { BoxHead, Underline } from "../../../Components/Styles/PageStyles";
import Table from "../../../Components/Landlords/Details/PropertiesTable";
import NotFoundModel from "../../../Components/NotFoundModel";
import { useEditLandlordLease, useLeaseDetails, useSaveLandlordPayment, useUploadLandlordDocument } from "../../../utilities/usePropertyLeaseHooks";
import { useSelector } from "react-redux";
import SideModal from "../../../Components/SideModal";
import ViewLeaseDetails from "../../../Components/Properties/Lease/ViewLeaseDetails";
import ManagePaymentDetails from "../../../Components/Landlords/ManagePaymentDetails";
import EditLandlordLeaseDetails from "../../../Components/Properties/Lease/EditLandlordLeaseDetails";
import { toast } from "react-toastify";

const Properties = ({
    propsData,
    getListMutate
    //handleMarkAsPaid,
    //setViewDetail,
}) => {
    const user = useSelector((state) => state.UserReducer.user);
    const [leaseData, setLeaseData] = useState("");
    const [showViewLeaseModel, setShowViewLeaseModel] = useState(false);
    const [selectedData, setSelectedData] = useState("");
    const [showEditLeaseModel, setShowEditLeaseModel] = useState(false);
    const [showManagePaymentModel, setShowManagePaymentModel] = useState(false);
    const [showUploadForm, setShowUploadForm] = useState(false);

    // Get Lease Details
    const { mutate: getLeaseDetails } =
        useLeaseDetails(user.token);

    const handleFetch = (params) => {
        getLeaseDetails(params, {
            onSuccess: (res) => {
                if (res?.data) {
                    if (res?.data?.leaseDetails) {
                        setLeaseData(res?.data);
                        setShowViewLeaseModel(true);
                    }
                }
            },
        });
    };

    const {
        mutate: editLandlordMutate,
        isLoading: editLandlordLoading,
    } = useEditLandlordLease({
        token: user.token,
        onSuccessCallback: (data) => {
            setShowEditLeaseModel(false);
            getListMutate();
            toast.success(data?.msg || "Success");
        },
        onErrorCallback: (error) => {
            toast.error(error?.response?.data?.msg || "An error occurred");
        },
    });

    const {
        mutate: savePaymentMutate,
        isLoading: savePaymentLoading,
    } = useSaveLandlordPayment({
        token: user.token,
        onSuccessCallback: (res) => {
            toast.success(res?.msg || "Payment details saved successfully");
            //refetch?.();
            setShowManagePaymentModel(false);
        },
        onErrorCallback: (error) => {
            toast.error(
                error?.response?.data?.msg ||
                error?.message ||
                "Failed to save payment details"
            );
        },
    });

    const {
        mutate: uploadDocumentMutate,
        isLoading: addDocumentLoading,
        data: documentData,
    } = useUploadLandlordDocument({
        token: user.token,
        onSuccessCallback: (res) => {
            if (res?.isSuccess === true) {
                toast.success(res?.msg || "Success");
                setShowUploadForm(false);
                setShowViewLeaseModel(false);
            } else {
                toast.error(res?.data?.msg || "An error occurred");
            }
        },
        onErrorCallback: (error) => {
            toast.error(
                error?.response?.data?.msg || "An error occurred"
            );
        },
    });

    return (
        <>
            <Wrapper>
                <BoxHead>
                    <BoxTitle className="!mb-0 whitespace-nowrap">
                        Properties
                        <Underline />
                    </BoxTitle>
                </BoxHead>
            </Wrapper>

            <SideModal
                isOpen={showViewLeaseModel}
                onClose={() => setShowViewLeaseModel(false)}
            >
                <ViewLeaseDetails
                    leaseData={leaseData}
                    handleClose={() => setShowViewLeaseModel(false)}
                    selectedData={selectedData}
                    setShowUploadForm={setShowUploadForm}
                    showUploadForm={showUploadForm}
                    addDocumentLoading={addDocumentLoading}
                    addDocumentMutate={uploadDocumentMutate}
                    documentData={documentData}
                    setShowEditLeaseModel={setShowEditLeaseModel}
                    setShowManagePaymentModel={setShowManagePaymentModel}
                    fromPage={"list"}
                />
            </SideModal>

            <SideModal
                isOpen={showManagePaymentModel}
                onClose={() => setShowManagePaymentModel(false)}
            >
                <ManagePaymentDetails
                    leaseData={leaseData}
                    handleClose={() => setShowManagePaymentModel(false)}
                    selectedData={selectedData}
                    savePaymentLoading={savePaymentLoading}
                    savePaymentMutate={savePaymentMutate}
                    setShowManagePaymentModel={setShowManagePaymentModel}
                />
            </SideModal>

            <SideModal
                isOpen={showEditLeaseModel}
                onClose={() => setShowEditLeaseModel(false)}
            >
                <EditLandlordLeaseDetails
                    leaseData={leaseData?.leaseDetails}
                    handleClose={() => setShowEditLeaseModel(false)}
                    editLandlordLoading={editLandlordLoading}
                    editLandlordMutate={editLandlordMutate}
                />
            </SideModal>

            {/* Table Section */}
            <div className="mt-4">
                <TableWrapper>
                    <Table
                        apiData={propsData || []}
                        setSelectedData={setSelectedData}
                        handleFetch={handleFetch}
                    />
                    {(propsData?.length === 0) &&
                        <NotFoundModel />}
                </TableWrapper>
            </div>
        </>
    );
};

const Wrapper = tw.div`px-4 space-y-4 mt-2`;
const TableWrapper = tw.h1`my-8 border bg-white rounded-md`;
const ScrollCard = tw.div`w-full overflow-x-auto  flex space-x-4 py-1`;
const Card = tw.div`min-w-[200px] p-3 rounded-md bg-white shadow-md cursor-pointer hover:shadow-sm hover:shadow-primary-color  ${({ selectedId, index }) => selectedId === index ? "shadow-sm shadow-primary-color" : ""}`;
const Label = tw.div`text-gray-500 text-sm break-words flex items-center w-full mt-2 justify-between break-words whitespace-normal w-full`;
const Value = tw.p`
  text-xl sm:text-2xl font-bold  text-black`;
const BoxTitle = tw.h2`
${(p) => (p.$fullWidth ? "flex inline-flex" : "justify-center")}
text-lg  text-black font-semibold  space-x-2 items-center  mb-5  rounded-md `;

export default Properties;
